"use client";
import { getRootElement } from "../../../core/utils/find-element-in-shadow-dom/find-element-in-shadow-dom.mjs";
//#region packages/@mantine/core/src/components/Combobox/is-external-input-change/is-external-input-change.ts
/**
* Determines whether an input change was produced by something other than the user typing into the
* input – browser autofill, password managers and browser extensions all write to inputs without
* focusing them first. Combobox components reconcile the search value with the selected value on
* blur, which never happens for such writes.
*/
function isExternalInputChange(event) {
	const target = event.currentTarget;
	return getRootElement(target).activeElement !== target;
}
//#endregion
export { isExternalInputChange };

//# sourceMappingURL=is-external-input-change.mjs.map